var Selection = /*#__PURE__*/function (Selection) {
  Selection[Selection["selected"] = 0] = "selected";
  Selection[Selection["unselected"] = 1] = "unselected";
  return Selection;
}({});
var State = /*#__PURE__*/function (State) {
  State[State["disabled"] = 0] = "disabled";
  State[State["enabled"] = 1] = "enabled";
  return State;
}({});

// TODO: ADSWEB-534 Add illustration when available

var ListImageAsset = function ListImageAsset(image) {
  var cornerRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fit';
  return {
    image: image,
    cornerRadius: cornerRadius,
    scale: scale
  };
};

export { ListImageAsset, Selection, State };
//# sourceMappingURL=ListItem.types.js.map
